export const API_GET_USER_IDENTITY = '/platformroles/:userId';
export const AUTH_STORE = 'auth';
export const GET_AUTH_STATE = 'get';
